import http from "@/untils/http"
let resquest = ''
import { fetchEventSource } from '@microsoft/fetch-event-source'
import cookie from "@/assets/js/cookie";
const getBaseUrl = (env) => {
    let base = {
      production: "/",
      development: "http://localhost:8080",
      test: "http://localhost:8080",
    }[env];
    if (!base) {
      base = "";
    }
    return base;
};
export default {

    freeLogin(params, isBody) {
        return http.post(`${resquest}/chataiapi/system/auth/free-login`,params, isBody)
    },

    portalTenant(params) {
        return http.get(`${resquest}/chataiapi/system/tenant/portal-tenant`,params)
    },
    
    createChatConversationMy(params, isBody) {
        return http.post(`${resquest}/chataiapi/ai/chat/conversation/create-my`,params, isBody)
    },


    updateChatConversationMy(params, isBody) {
        return http.put(`${resquest}/chataiapi/ai/chat/conversation/update-my`,params, isBody)
    },

    
    getChatConversationMyList(params) {
        return http.get(`${resquest}/chataiapi/ai/chat/conversation/my-list`,params)
    },

    getChatConversationMy(params) {
        return http.get(`${resquest}/chataiapi/ai/chat/conversation/get-my?id=`+params)
    },

    getChatMessageListByConversationId(params) {
        return http.get(`${resquest}/chataiapi/ai/chat/message/list-by-conversation-id?conversationId=`+params)
    },

    updateConversation(params) {
        return http.get(`${resquest}/chataiapi/ai/chat/message/update-interrupted-by-conversation-id?messageId=`+params)
    },

    deleteChatMessage(params) {
        return http.delete(`${resquest}/chataiapi/ai/chat/message/delete?id=`+params)
    },

    deleteByConversationId(params) {
        return http.delete(`${resquest}/chataiapi/ai/chat/message/delete-by-conversation-id?conversationId=`+params)
    },

    deleteChatConversationMy(params) {
        return http.delete(`${resquest}/chataiapi/ai/chat/conversation/delete-my?id=`+params)
    },

    deleteChatConversationMyByUnpinned(params) {
        return http.delete(`${resquest}/chataiapi/ai/chat/conversation/delete-by-unpinned`,params)
    },

    refreshToken(params) {
        return http.post(`${resquest}/chataiapi/system/auth/refresh-token?refreshToken=`+params)
    },

    // 发送 Stream 消息
    sendChatMessageStream: async (
        conversationId,
        content,
        filePath,
        fileName,
        useKnowledge,
        ctrl,
        enableContext,
        onMessage,
        onError,
        onClose
    ) => {
        let token = cookie.getCookie("ai_token");
        let origin = document.location.origin;
        let baseurl = '';
        if (origin.indexOf("localhost") >= 0 || origin.indexOf("127.0.0.1") >= 0) {
            baseurl = "/api";
        }
        return fetchEventSource(`${getBaseUrl(process.env.BASE_API)}${baseurl}/chataiapi/ai/chat/message/send-stream`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            openWhenHidden: true,
            body: JSON.stringify({
                conversationId,
                content,
                filePath,
                fileName,
                useKnowledge,
                useContext: enableContext
            }),
            onmessage: onMessage,
            onerror: onError,
            onclose: onClose,
            signal: ctrl.signal
        })
    },

    // 继续未完成的消息流
    resumeChatMessageStream: async (
        conversationId,
        messageId,
        content,
        useKnowledge,
        ctrl,
        onMessage,
        onError,
        onClose
    ) => {
        let token = cookie.getCookie("ai_token");
        let origin = document.location.origin;
        let baseurl = '';
        if (origin.indexOf("localhost") >= 0 || origin.indexOf("127.0.0.1") >= 0) {
            baseurl = "/api";
        }
        return fetchEventSource(`${getBaseUrl(process.env.BASE_API)}${baseurl}/chataiapi/ai/chat/message/resume-stream`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            openWhenHidden: true,
            body: JSON.stringify({
                conversationId,
                messageId,
                content,
                useKnowledge,
            }),
            onmessage: onMessage,
            onerror: onError,
            onclose: onClose,
            signal: ctrl.signal
        })
    },

    // 账号锐豆查询
    queryAccountRuidou(params) {
        return http.post(`${resquest}/aiapi/ruidou/query_account_ruidou`,params)
    },
    // 账号充值/消费列表
    queryRuidouRecordList(params) {
        return http.post(`${resquest}/aiapi/ruidou/query_ruidouRecord_list`,params)
    },

    goRuidouPreorder(params) {
        return http.post(`${resquest}/payapi/go_wxpay_ruidou_preorder`,params);
    },

    checkOrderAPI(params) {
        return http.post(`${resquest}/payapi/check_order`,params);
    },

    // 锐豆消耗
    deductRuidou(params, isBody) {
        return http.post(`${resquest}/aiapi/ruidou/deduct_ruidou`,params, isBody)
    },

}